import { createSelector } from 'reselect';

const getMe = state => state.app.get('me');

export default createSelector([getMe], me => ({ me }));